import ProviderEmpty from './provider-empty';

export default ProviderEmpty;
